export const PREFIX = 'QUEUING_LOTTERY_';

export const GET_LOTTERY = `${PREFIX}GET_LOTTERY`;
export const GET_LOTTERIES = `${PREFIX}GET_LOTTERIES`;
export const GET_LOTTERY_APPLICATION = `${PREFIX}GET_LOTTERY_APPLICATION`;
export const GET_USER_EAP_LOTTERY_STATUS = `${PREFIX}GET_USER_EAP_LOTTERY_STATUS`;
export const RESET_LOTTERIES = `${PREFIX}RESET_LOTTERIES`;
export const CREATE_LOTTERY_APPLICATION = `${PREFIX}CREATE_LOTTERY_APPLICATION`;
export const UPDATE_LOTTERY_APPLICATION = `${PREFIX}UPDATE_LOTTERY_APPLICATION`;

export const GET_INVENTORY_CONTENT = `${PREFIX}GET_INVENTORY_CONTENT`;
